import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SchedulingPollForm.title',
    defaultMessage: 'Title',
  },
  titlePlaceholder: {
    id: 'containers.SchedulingPollForm.titlePlaceholder',
    defaultMessage: 'e.g., Project Kickoff Meeting',
  },
  description: {
    id: 'containers.SchedulingPollForm.description',
    defaultMessage: 'Description (Optional)',
  },
  descriptionPlaceholder: {
    id: 'containers.SchedulingPollForm.descriptionPlaceholder',
    defaultMessage: 'Add any context or details...',
  },
  includeBranding: {
    id: 'containers.SchedulingPollForm.includeBranding',
    defaultMessage: 'Include branding',
  },
  defaultDuration: {
    id: 'containers.SchedulingPollForm.defaultDuration',
    defaultMessage: 'Default meeting duration (minutes)',
  },
  defaultDurationDescription: {
    id: 'containers.SchedulingPollForm.defaultDurationDescription',
    defaultMessage: 'This duration will be used when quickly adding time slots',
  },
  timeSlotOptions: {
    id: 'containers.SchedulingPollForm.timeSlotOptions',
    defaultMessage: 'Time Slot Options * ({count, plural, one {# slot} other {# slots}})',
  },
  calendar: {
    id: 'containers.SchedulingPollForm.calendar',
    defaultMessage: 'Calendar',
  },
  manual: {
    id: 'containers.SchedulingPollForm.manual',
    defaultMessage: 'Manual',
  },
  calendarInstructions: {
    id: 'containers.SchedulingPollForm.calendarInstructions',
    defaultMessage: 'Click on a time to add a {duration}-minute slot, or drag to create a custom-length slot. Click on existing slots to remove them.',
  },
  manualInstructions: {
    id: 'containers.SchedulingPollForm.manualInstructions',
    defaultMessage: 'Manually specify start and end times for each slot',
  },
  startTime: {
    id: 'containers.SchedulingPollForm.startTime',
    defaultMessage: 'Start Time',
  },
  endTime: {
    id: 'containers.SchedulingPollForm.endTime',
    defaultMessage: 'End Time',
  },
  to: {
    id: 'containers.SchedulingPollForm.to',
    defaultMessage: 'to',
  },
  removeTimeSlot: {
    id: 'containers.SchedulingPollForm.removeTimeSlot',
    defaultMessage: 'Remove time slot',
  },
  addTimeSlot: {
    id: 'containers.SchedulingPollForm.addTimeSlot',
    defaultMessage: '+ Add Time Slot',
  },
  timeSlotsSummaryLabel: {
    id: 'containers.SchedulingPollForm.timeSlotsSummaryLabel',
    defaultMessage: 'Time Slots ({count, plural, one {# slot} other {# slots}}):',
  },
  existing: {
    id: 'containers.SchedulingPollForm.existing',
    defaultMessage: 'existing',
  },
  new: {
    id: 'containers.SchedulingPollForm.new',
    defaultMessage: 'new',
  },
  remove: {
    id: 'containers.SchedulingPollForm.remove',
    defaultMessage: 'Remove',
  },
  cancel: {
    id: 'containers.SchedulingPollForm.cancel',
    defaultMessage: 'Cancel',
  },
  addedTimeSlotToast: {
    id: 'containers.SchedulingPollForm.addedTimeSlotToast',
    defaultMessage: 'Added time slot: {start} - {end}',
  },
  removeSlotConfirm: {
    id: 'containers.SchedulingPollForm.removeSlotConfirm',
    defaultMessage: 'Remove this time slot?\n{start} - {end}',
  },
  removeExistingSlotWarning: {
    id: 'containers.SchedulingPollForm.removeExistingSlotWarning',
    defaultMessage: 'Remove this time slot? Existing votes for this slot will be preserved but the slot will no longer be shown.\n{start} - {end}',
  },
  titleRequired: {
    id: 'containers.SchedulingPollForm.titleRequired',
    defaultMessage: 'Title is required',
  },
  atLeastOneSlot: {
    id: 'containers.SchedulingPollForm.atLeastOneSlot',
    defaultMessage: 'At least one time slot is required',
  },
  slotTimesRequired: {
    id: 'containers.SchedulingPollForm.slotTimesRequired',
    defaultMessage: 'Time slot {slotNumber}: Both start and end times are required',
  },
  invalidDatetime: {
    id: 'containers.SchedulingPollForm.invalidDatetime',
    defaultMessage: 'Time slot {slotNumber}: Invalid datetime format',
  },
  endAfterStart: {
    id: 'containers.SchedulingPollForm.endAfterStart',
    defaultMessage: 'Time slot {slotNumber}: End time must be after start time',
  },
})
